/**
    * @description      : 
    * @author           : Saif
    * @group            : 
    * @created          : 04/11/2024 - 21:22:52
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 04/11/2024
    * - Author          : Saif
    * - Modification    : 
**/
import { useState, useEffect, useRef } from "react";
//y
import { DashboardLayout } from "./../../Components/Layout/DashboardLayout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowCircleDown,
  faCreditCard,
  faExternalLinkAlt,
  faBuilding,
  faUsers,
  faCalendarDays,
  faMoneyBill,
  faHeart,
} from "@fortawesome/free-solid-svg-icons";
import { male1, male2, userImage, female1, male3 } from "../../Assets/images";
import { useApi, useGet, usePost } from "../../Api";

import "./style.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FormatDateTime from "../../Components/DateFormate";
import CustomTable from "../../Components/CustomTable";
import CustomModal from "../../Components/CustomModal";
import CustomButton from "../../Components/CustomButton";

export const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isStripeReturn = queryParams.get('stripe_onboarding') === 'return';
  // Preserve the initial return flag across URL cleanup re-renders
  const hasStripeReturnedRef = useRef(isStripeReturn);

  const [data, setData] = useState('');
  const [lead, setLead] = useState('');
  const [recived, setReceived] = useState('');
  const [amount, setAmount] = useState('');
  const [showStripeModal, setShowStripeModal] = useState(false);
  const [showStripeSuccessModal, setShowStripeSuccessModal] = useState(false);
  const [stripeOnboardingUrl, setStripeOnboardingUrl] = useState('');
  const [userData, setUserData] = useState(null);
  
  const { ApiData: DashboardStatsData, loading: DashboardStatsLoading, error: DashboardStatsError, get: GetDashboardStats } = useGet(`/dashboard/stats`);
  const { ApiData: StripeAccountData, loading: StripeAccountLoading, error: StripeAccountError, post: GetStripeAccount } = usePost(`/stripe/refresh-account`);
  const { ApiData: CreateStripeAccountData, loading: CreateStripeAccountLoading, error: CreateStripeAccountError, post: CreateStripeAccount } = usePost(`/stripe/create-account`);

  useEffect(() => {
    document.title = 'kvr User | Dashboard';
    GetDashboardStats();
    
    // Get user data from localStorage
    const userInfo = localStorage.getItem('userInfo');
    if (userInfo) {
      setUserData(JSON.parse(userInfo));
    }
  }, []);

  // Check Stripe account status for hosts
  useEffect(() => {
    if (userData && userData.role === "2") {
      GetStripeAccount({});
    }
  }, [userData]);

  useEffect(() => {
    const handleVisibility = () => {
      if (document.visibilityState === 'visible' && userData?.role === "2") {
        GetStripeAccount({});
      }
    };
    document.addEventListener('visibilitychange', handleVisibility);
    return () => document.removeEventListener('visibilitychange', handleVisibility);
  }, [userData]);

  useEffect(() => {
    if (StripeAccountData?.data?.onboarding_url) {
      setStripeOnboardingUrl(StripeAccountData.data.onboarding_url);
    }
  }, [StripeAccountData]);

  useEffect(() => {
    const status = StripeAccountData?.data?.status;
    if (!status) return;

    const completeStatuses = ['active', 'complete', 'verified', 'enabled'];
    if (completeStatuses.includes(status) && hasStripeReturnedRef.current) {
      setShowStripeSuccessModal(true);
      hasStripeReturnedRef.current = false;
    }
  }, [StripeAccountData]);

  // Clean Stripe onboarding return URL param
  useEffect(() => {
    if (isStripeReturn) {
      navigate('/dashboard', { replace: true });
    }
  }, [isStripeReturn, navigate]);

  useEffect(() => {
    if (DashboardStatsData) {
      setData(DashboardStatsData)
    }
  }, [DashboardStatsData])

  // Handle Stripe account creation
  useEffect(() => {
    if (CreateStripeAccountData && CreateStripeAccountData.success) {
      setStripeOnboardingUrl(CreateStripeAccountData.data.onboarding_url);
      setShowStripeModal(true);
      // Refresh the Stripe account status after creation
      setTimeout(() => {
        GetStripeAccount({});
      }, 1000);
    }
  }, [CreateStripeAccountData]);

  // Refresh Stripe account status when modal is closed
  const handleCloseModal = () => {
    setShowStripeModal(false);
    // Refresh status after modal closes
    if (userData && userData.role === "2") {
      GetStripeAccount({});
    }
  };

  const handleCreateStripeAccount = () => {
    if (userData) {
      const payload = {
        email: userData.email,
        business_name: userData.name,
        country: "US", // You can make this dynamic if needed
        type: "express"
      };
      CreateStripeAccount(payload);
    }
  };

  const handleNavigateToStripe = () => {
    const url = stripeOnboardingUrl || StripeAccountData?.data?.onboarding_url;
    if (url) {
      window.open(url, '_blank');
      setShowStripeModal(false);
    }
  };

  const handleContinueStripeOnboarding = () => {
    const url = stripeOnboardingUrl || StripeAccountData?.data?.onboarding_url;
    if (url) {
      window.open(url, '_blank');
    } else {
      handleCreateStripeAccount();
    }
  };

  console.log(data);

  const upcomingHeader = [
    {
      key: "id",
      title: "S.No",
    },
    {
      key: "username",
      title: "Name",
    },
    {
      key: "emai",
      title: "Email",
    },
    {
      key: "read",
      title: "Address",
    },
    {
      key: "status",
      title: "Guests",
    },

    {
      key: "created_at",
      title: "Check in",
    },
    {
      key: "action",
      title: "Check out",
    },
    {
      key: 'amount',
      title: 'Amount'
    },
    {
      key: 'date',
      title: 'Date'
    },
    {
      key: 'status',
      title: 'Status'
    }
  ];

  const upcomingTripsHeader = [
    {
      key: "id",
      title: "S.No",
    },
    {
      key: "listing_name",
      title: "Listing",
    },
    {
      key: "listing_address",
      title: "Location",
    },
    {
      key: "check_in",
      title: "Check In",
    },
    {
      key: "check_out",
      title: "Check Out",
    },
    {
      key: "guests",
      title: "Guests",
    },
    {
      key: "amount",
      title: "Amount",
    },
    {
      key: "status",
      title: "Status",
    },
    {
      key: "action",
      title: "Action",
    },
  ];

  const formatTripDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const getConfirmationStatus = (status) => {
    if (status === "1" || status === 1) return { label: "Confirmed", className: "text-success" };
    if (status === "2" || status === 2) return { label: "Cancelled", className: "text-danger" };
    return { label: "Pending", className: "text-warning" };
  };

  // Check if user is a host and needs Stripe setup
  const isHost = userData && userData.role === "2";
  const isRenter = userData && userData.role === "3";
  const stripeStatus = StripeAccountData?.data?.status;
  const needsStripeSetup = isHost && stripeStatus && ['not_created', 'pending', 'incomplete', 'restricted'].includes(stripeStatus);
  const stripeNeedsContinue = isHost && stripeStatus && ['pending', 'incomplete'].includes(stripeStatus);

  // Get dashboard stats based on role
  const getDashboardStats = () => {
    if (isHost) {
      return [
        {
          title: "My Listings",
          value: data?.listings?.count || 0,
          icon: faBuilding,
          color: "primary",
          to: "/listing-management"
        },
        {
          title: "Total Reservations",
          value: data?.reservations?.count || 0,
          icon: faUsers,
          color: "success",
          to: "/reservation"
        },
        {
          title: "Upcoming Bookings",
          value: data?.upcoming_reservations?.data?.length || 0,
          icon: faCalendarDays,
          color: "warning",
          to: "/reservation"
        },
        {
          title: "Total Earnings",
          value: `$${(parseFloat(data?.total_earnings) || 0).toFixed(2)}`,
          icon: faMoneyBill,
          color: "info",
          to: "/wallet",
          hint: "Paid to you by Kayifi · View details"
        }
      ];
    } else if (isRenter) {
      return [
        {
          title: "My Reservations",
          value: data?.reservations?.count || 0,
          icon: faUsers,
          color: "primary",
          to: "/reservation"
        },
        {
          title: "Upcoming Trips",
          value: data?.upcoming_reservations?.data?.length || 0,
          icon: faCalendarDays,
          color: "success",
          to: "/reservation"
        },
        {
          title: "Total Spent",
          value: `$${(parseFloat(data?.total_spent) || 0).toFixed(2)}`,
          icon: faMoneyBill,
          color: "warning",
          to: "/user-invoice"
        },
        {
          title: "Pending Payment",
          value: `$${(parseFloat(data?.total_pending) || 0).toFixed(2)}`,
          icon: faCreditCard,
          color: "danger",
          to: "/user-invoice"
        }
      ];
    }
    return [];
  };

  const dashboardStats = getDashboardStats();

  return (
    <>
      <DashboardLayout>
        <div className="container-fluid">
          {/* Welcome Message */}
          <div className="row mb-4">
            <div className="col-12">
              <div className="welcome-section">
                <h2 className="welcome-title">
                  Welcome back, {userData?.name || 'User'}!
                </h2>
                <p className="welcome-subtitle">
                  {isHost ? 'Manage your properties and track your earnings' : 'Track your bookings and manage your trips'}
                </p>
              </div>
            </div>
          </div>

          {/* Stripe Setup Alert for Hosts */}
          {needsStripeSetup && (
            <div className="row mb-4">
              <div className="col-12">
                <div className="alert alert-warning d-flex align-items-center justify-content-between flex-wrap gap-2" role="alert">
                  <div>
                    <FontAwesomeIcon icon={faCreditCard} className="me-2" />
                    <strong>Stripe Account Required:</strong>{' '}
                    {stripeNeedsContinue
                      ? 'Your Stripe onboarding is incomplete. Please continue to start receiving payments.'
                      : 'To receive payments for your listings, you need to set up your Stripe account.'}
                  </div>
                  <CustomButton 
                    variant="primary" 
                    text={stripeNeedsContinue ? 'Continue Onboarding' : 'Setup Stripe Account'}
                    onClick={stripeNeedsContinue ? handleContinueStripeOnboarding : handleCreateStripeAccount}
                    disabled={CreateStripeAccountLoading}
                  />
                </div>
              </div>
            </div>
          )}

          {/* Dashboard Stats */}
          <div className="row mb-3">
            <div className="col-12">
              <div className="dashCard">
                <div className="row">
                  {dashboardStats.map((stat, index) => (
                    <div key={index} className="col-xl-3 col-md-6 stats">
                      {/* Every card opens the page where the number comes from */}
                      <Link to={stat.to} className="statsCard statsCardLink" title={`Open ${stat.title}`}>
                        <div className="statsContent">
                          <div className="statsData">
                            <h3 className="statsNumber">{stat.value}</h3>
                            <p className="statsText">{stat.title}</p>
                            {stat.hint && <p className="statsHint">{stat.hint}</p>}
                          </div>
                          <div className="statsIcon">
                            <FontAwesomeIcon icon={stat.icon} className={`text-${stat.color}`} />
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

         

       
          {/* Upcoming Trips / Bookings Section */}
          {(isHost || isRenter) && (
            <div className="row mb-4">
              <div className="col-12">
                <div className="dashCard">
                  <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
                    <h3 className="mainTitle mb-0">
                      {isHost ? "Upcoming Bookings" : "Upcoming Trips"}
                    </h3>
                    <Link to="/reservation" className="text-decoration-none text-primary">
                      View All
                    </Link>
                  </div>
                  {data?.upcoming_reservations?.data?.length > 0 ? (
                    <CustomTable headers={upcomingTripsHeader}>
                      <tbody>
                        {data.upcoming_reservations.data.map((item, index) => {
                          const confirmation = getConfirmationStatus(item?.confirmation_status);
                          return (
                            <tr key={item?.id || index}>
                              <td>{index + 1}</td>
                              <td>
                                <Link to={`/listing-detial/${item?.list_id}`} className="text-decoration-none">
                                  {item?.listing_name || "-"}
                                </Link>
                              </td>
                              <td>{item?.listing_address || item?.address || "-"}</td>
                              <td>{formatTripDate(item?.check_in)}</td>
                              <td>{formatTripDate(item?.check_out)}</td>
                              <td>{item?.guests ?? "-"}</td>
                              <td>${item?.total ?? item?.subtotal ?? 0}</td>
                              <td className={confirmation.className}>{confirmation.label}</td>
                              <td>
                                <Link
                                  to="/reservation"
                                  className="btn btn-sm btn-primary"
                                >
                                  View
                                </Link>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </CustomTable>
                  ) : (
                    <p className="text-muted mb-0">No upcoming {isHost ? "bookings" : "trips"} found.</p>
                  )}
                </div>
              </div>
            </div>
          )}

        </div>
        <CustomModal 
          show={showStripeModal} 
          close={handleCloseModal} 
          heading="Complete Your Stripe Onboarding"
        >
          <div className="text-center p-4 customSize">
            <div className="mb-4">
              <div className="stripe-success-icon mb-3">
                <FontAwesomeIcon 
                  icon={faCreditCard} 
                  style={{ 
                    fontSize: '3rem', 
                    color: '#6772e5',
                    backgroundColor: '#f8f9ff',
                    padding: '1rem',
                    borderRadius: '50%',
                    border: '2px solid #e6e8ff'
                  }} 
                />
              </div>
              <h4 className="text-primary mb-3">Stripe Account Created</h4>
              <p className="text-muted mb-4">
                Your Stripe account has been created. Complete the onboarding process with Stripe
                to start receiving payments for your listings.
              </p>
            </div>
            
            <div className="alert alert-info mb-4" role="alert">
              <div className="d-flex align-items-start">
                <FontAwesomeIcon icon={faExternalLinkAlt} className="me-2" />
                <small>
                  <strong>Note:</strong> You'll be redirected to Stripe's secure onboarding page in a new tab.
                </small>
              </div>
            </div>
            
            <div className="d-flex gap-3 justify-content-center">
              <CustomButton 
                variant="outline-secondary" 
                text="Cancel" 
                onClick={handleCloseModal}
              />
              <CustomButton 
                variant="primary" 
                text="Complete Onboarding" 
                onClick={handleNavigateToStripe}
                // icon={faExternalLinkAlt}
                style={{
                  background: 'linear-gradient(135deg, #6772e5 0%, #5a67d8 100%)',
                  border: 'none',
                  boxShadow: '0 4px 12px rgba(103, 114, 229, 0.3)'
                }}
              />
            </div>
          </div>
        </CustomModal>

        {/* Stripe Onboarding Success Modal */}
        <CustomModal
          show={showStripeSuccessModal}
          close={() => setShowStripeSuccessModal(false)}
          success
          heading="Stripe onboarding completed successfully! You can now receive payments."
          btnTxt="OK"
        />
      </DashboardLayout>
    </>
  );
};
